// 快訊頁上方日曆
'use client';

import { useState } from 'react';
import FlashCalendarTimeline from './FlashCalendarTimeline'; // 日曆時間軸
import FlashCalendarContent from './FlashCalendarContent'; // 日曆內容
import FlashList from '@/components/flash/FlashList'; // 快訊列表

const FlashCalendarList = ({ list = {}, today, locale }) => {
    // 選中的日期
    const [selectedDate, setSelectedDate] = useState(today);
    // 顯示內容
    const selectedContent = list?.[selectedDate];

    if (list)
        return (
            <div className="flex-grow max-w-[728px] ulg:w-full ulg:max-w-[unset]">
                {/* 日曆時間軸 */}
                <FlashCalendarTimeline
                    list={list}
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    locale={locale}
                />

                {/* 日曆內容 */}

                {selectedContent?.news || selectedContent?.calendar?.length ? (
                    <FlashCalendarContent selectedContent={selectedContent} locale={locale} />
                ) : (
                    <></>
                )}

                {/* 快訊 列表 */}
                <FlashList locale={locale} selectedDate={selectedDate} />
            </div>
        );

    return <></>;
};

export default FlashCalendarList;
